import { dashboard } from '../action-types';

const initialState = {
  data: null,
  isFetching: false,
  isFetchingTagihan: false,
  dataTagihan: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case dashboard.FETCH_DASHBOARD:
      return {
        ...state,
        isFetching: true,
      };
    case dashboard.GET_DASHBOARD:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
      };
    case dashboard.FETCH_DASHBOARD_TAGIHAN:
      return {
        ...state,
        isFetchingTagihan: true,
      };
    case dashboard.GET_DASHBOARD_TAGIHAN:
      return {
        ...state,
        isFetchingTagihan: false,
        dataTagihan: action.payload,
      };
    case dashboard.NULL_DASHBOARD_TAGIHAN:
      return {
        ...state,
        isFetchingTagihan: false,
        dataTagihan: null,
      };
    default:
      return state;
  }
};
